// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__23FB4","inputDescription":"styles_inputDescription__3fNqo"};